import React, { useCallback, useState, useRef } from 'react';
import RenderPdfSo from './RenderPdfSo';
import TreeProcesso from './TreeProcesso';


const index = ({dataTree}) => {
  const {numero, numeroAno, itens, previewPath} = dataTree.processo;
  const [fileSelected, setFileSelected]     = useState();
  const [processandoPdf, setProcessandoPdf] = useState(false);
  
  const ref0 = useRef();
  const ref1 = useRef();
  const ref2 = useRef();

  const [toggle, setToggle] = useState(2);
  const [toggleF, setToggleF] = useState(true);

  const toggleBoth = () => {
    if (!ref0.current) return;

      ref1.current.style.display = 'block';
      ref2.current.classList.remove('col-12');
      ref2.current.classList.add('col-9');

      ref2.current.style.display = 'block';
      ref1.current.classList.remove('col-12');
      ref1.current.classList.add('col-3');

      setToggle(2);
  };

  const toggleRight = () => {
    if (!ref0.current) return;

    toggleBoth();

    ref1.current.style.display = 'none';
    ref2.current.classList.remove('col-9');
    ref2.current.classList.add('col-12');

    setToggle(0);
  };

  const toggleLeft = () => {
    if (!ref0.current) return;

    toggleBoth();

    ref2.current.style.display = 'none';
    ref1.current.classList.remove('col-3');
    ref1.current.classList.add('col-12');

    setToggleR(1);
  };

  const toggleFull = () => {
    if (!ref0.current) return;
    const row = ref0.current;

    if (toggleF) {
      Object.assign(row.style, {
        position: 'fixed',
        left: '0',
        top: '0',
        right: '0',
        bottom: '0',
      });
    } else {
      Object.assign(row.style, {
        position: null,
        left: null,
        top: null,
        right: null,
        bottom: null,
      });
    }
    setToggleF(!toggleF);
  };

  const handleShowFile = useCallback((file) => {
    setFileSelected(file);
    setProcessandoPdf(true);
  }, []);

  const handleProcessandoPdf = (status) => {
    setProcessandoPdf(status);
  };

  const showSplit = innerWidth > 600;

  return (
    <>
      <div className='container body-vh-full'>
        <div className='row bg-dark' ref={ref0}>
          <div className="col-12">
            {showSplit && <button className="btn btn-dark" onClick={toggleBoth}>
              <i className='fa fa-columns'></i>
            </button>}
            <button className="btn btn-dark" onClick={toggleLeft}>
              <i className='fa fa-list'></i>
            </button>
            <button className="btn btn-dark" onClick={toggleRight}>
              <i className='fa fa-file'></i>
            </button>
            <button className="btn btn-dark" onClick={toggleFull}>
              <i className='fa fa-window-maximize'></i>
            </button>
          </div>
          <div className='col-3 card body-vh-full'
               ref={ref1}
               style={{backgroundColor: '#303437', overflowY: 'auto', overflowX: 'hidden'}}>
            <TreeProcesso numero={numero}
                          itens={itens}
                          handleShowFile={handleShowFile}
                          processandoPdf={processandoPdf} />
          </div>
          <div className='col-9 p-0 card body-vh-full overflow-auto' ref={ref2}>
            <RenderPdfSo numeroAno={numeroAno}
                         file={fileSelected}
                         previewPath={previewPath}
                         handleProcessandoPdf={handleProcessandoPdf} />
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
